import { render, staticRenderFns } from "./NewAccommodationReservationFormTest.vue?vue&type=template&id=65eed00b&scoped=true&"
import script from "./NewAccommodationReservationFormTest.vue?vue&type=script&lang=js&"
export * from "./NewAccommodationReservationFormTest.vue?vue&type=script&lang=js&"
import style0 from "./NewAccommodationReservationFormTest.vue?vue&type=style&index=0&id=65eed00b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eed00b",
  null
  
)

export default component.exports